import mutations from '../mutations';
import api from '../../api';

export default {
  namespaced: true,
  state: {
    loading: false,
    status: null
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getAll({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.categoryPortal
        .getAll(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    create({ commit }, payload) {
      commit(mutations.LOADING);
      return api.categoryPortal
        .create(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    },
    update({ commit }, { id, params }) {
      commit(mutations.LOADING);
      return api.categoryPortal
        .update(id, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    detail({ commit }, id) {
      commit(mutations.LOADING);
      return api.categoryPortal
        .detail(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    delete({ commit }, id) {
      commit(mutations.LOADING);
      return api.categoryPortal
        .delete(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    getDoc({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.categoryPortal
        .getDoc(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    uploadDoc({ commit }, payload) {
      commit(mutations.LOADING);
      return api.categoryPortal
        .uploadDoc(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    }
  },
  getters: {}
};
